import { LinkButton } from '@e3dc-react/shell/Elements/Buttons'
import { Typography } from '@mui/material'
import { Variant } from '@mui/material/styles/createTypography'
import React from 'react'

export interface LinkVariantProps {
  type: 'email' | 'newTab' | 'button' | 'phone' | 'link'
  link?: string
  label?: string
  onClick?: () => void
  linkClassName?: string
  textClassName?: string
  hasUnderline?: boolean
  textVariant?: Variant
  clickable?: boolean
}

/**
 * This component implements different types of links
 * email: opens a new window in which you can send an email to the given link (email)
 * newTab: opens a new tab with the given link (url)
 * button: button which looks like a link
 * phone: opens a phone app with given link (phone number)
 */
const LinkVariant: React.VFC<LinkVariantProps> = ({
  type,
  link,
  label,
  linkClassName,
  textClassName,
  onClick,
  hasUnderline = true,
  textVariant = 'overline',
  clickable = true,
}) => {
  const content = label ?? link ?? ''
  switch (type) {
    case 'email':
      return (
        <LinkButton
          linkClassName={linkClassName}
          hasUnderline={hasUnderline}
          clickable
          content={
            <Typography className={textClassName} variant={textVariant}>
              {content}
            </Typography>
          }
          onClick={() => window.open('mailto:' + link)}
        />
      )
    case 'newTab':
      return (
        <LinkButton
          linkClassName={linkClassName}
          hasUnderline={hasUnderline}
          clickable
          content={
            <Typography className={textClassName} variant={textVariant}>
              {content}
            </Typography>
          }
          onClick={() => window.open(link)}
        />
      )
    case 'button':
      return (
        <LinkButton
          linkClassName={linkClassName}
          hasUnderline={hasUnderline}
          clickable
          content={
            <Typography className={textClassName} variant={textVariant}>
              {content}
            </Typography>
          }
          onClick={onClick}
        />
      )
    case 'link':
      return (
        <LinkButton
          linkClassName={linkClassName}
          hasUnderline={false}
          clickable={clickable}
          link={link}
          content={
            <Typography color={'primary'} className={textClassName} variant={textVariant}>
              {content}
            </Typography>
          }
        />
      )
    case 'phone':
      return (
        <LinkButton
          linkClassName={linkClassName}
          hasUnderline={hasUnderline}
          clickable
          content={
            <Typography className={textClassName} variant={textVariant}>
              {content}
            </Typography>
          }
          onClick={() => window.open('tel:' + content, '_self')}
        />
      )
    default:
      return (
        <LinkButton
          linkClassName={linkClassName}
          hasUnderline={hasUnderline}
          clickable
          content={<Typography variant={textVariant}>{content}</Typography>}
          onClick={() => window.open(link)}
        />
      )
  }
}

export default LinkVariant
